import { useWorkspaceDocumentVersionStore } from "@/stores/workspace-document-version.store";
import { useDocumentReferenceStore } from "@/stores/document-reference.store";
import { useNewConversationFiltersStore } from "@/stores/new-conversation-filters.store";
import useFeatureStore from "@/stores/feature.store";
import { useConversationTableStore } from "@/stores/conversation-table-state.store";
import useLawDictionaryStore from "@/stores/law-dictionary-control.store";
import useSearchStore from "@/stores/search.store";
import { logger } from "@/lib/logger";
import { FC, PropsWithChildren } from "react";
import { ResetStoresContext } from "./ResetStoresContext";

const ResetStoresProvider: FC<PropsWithChildren> = ({ children }) => {
  const { resetWorkspaceDocumentVersionStore } =
    useWorkspaceDocumentVersionStore();
  const { resetFilters } = useNewConversationFiltersStore();
  const { reset: resetDocumentReference } = useDocumentReferenceStore();
  const { reset: resetFeature } = useFeatureStore();
  const { reset: resetLawDictionary } = useLawDictionaryStore();
  const { resetTableState } = useConversationTableStore();
  const { resetWorkspaceContext } = useNewConversationFiltersStore();
  const { resetSearchFilter } = useSearchStore();

  const resetStores = () => {
    // Reset all stores in parallel for better performance
    Promise.all([
      resetWorkspaceDocumentVersionStore(),
      resetFilters(),
      resetDocumentReference(),
      resetFeature(),
      resetLawDictionary(),
      resetTableState(),
      resetWorkspaceContext(),
      resetSearchFilter(),
    ]).catch((error) => {
      logger.error("Failed to reset stores", {
        operation: "resetStores",
        error,
      });
    });
  };

  return (
    <ResetStoresContext.Provider
      value={{
        resetStores,
      }}
    >
      {children}
    </ResetStoresContext.Provider>
  );
};

export default ResetStoresProvider;
